import { DutyLineNote } from 'RestAPIs/employees/hours-table/types';
import { FlexRequestAction } from './consts';
import {
  CreatedBy,
  PreferredEmployee
} from 'components/shared/PreferredEmployees.types';
import { RequestQualifications } from 'RestAPIs/employees/qualifications/types';

type ISODateString = string;
export interface EmployeeCostCenterAction {
  id: number | null;
  requestId: number | null;
  employeeCostCenterType:
    | 'PREFERENCE1'
    | 'DEPLOYABLE_AS_FLEX_PREFERENCE1'
    | 'FLEX'
    | 'DEPLOYABLE_AS_FLEX'
    | string;
  action: 'NONE' | 'SUBSCRIBE' | 'CONNECT' | string;
  costCenterId: number | null;
}

export interface Period {
  dutyHourType: string | null;
  startTime: ISODateString;
  endTime: ISODateString;
}

export type FlexRequestActionType = {
  [K in keyof typeof FlexRequestAction as Lowercase<
    K & string
  >]: (typeof FlexRequestAction)[K];
};

export type AgenciesNotification = {
  emailAddress: string;
  requestId: number;
  agencyBrId: number;
  sentTime: ISODateString;
  flexRequestId: number;
  agencyName: string;
  sentUserId: number;
};

export type Note = {
  flags: string[];
  id: number;
  content: string;
};

export interface FlexMatchTaskResponse {
  date: ISODateString;
  costCenterCode: string;
  reason: string;
  notes: Note[];
  dutyCode: string;
  sentToFlexDate: ISODateString;
  costCenterNameShort: string;
  employeeCostCenterActions: EmployeeCostCenterAction[];
  qualifications: RequestQualifications[];
  dutyEndTime: ISODateString;
  functionId: number;
  costCenterId: number;
  requestId: number;
  taskVariables: {
    name: string;
    value: string;
  }[];
  functionDescription: string;
  periods: Period[];
  dutyId: number;
  planner: string;
  poolName: string;
  sendToFlex?: ISODateString;
  displayDutyColorCode: string;
  processInstanceId: string;
  agenciesNotifications: AgenciesNotification[];
  originatingCostCenterId: number;
  functionName: string;
  dutyStartTime: ISODateString;
  displayDutyCode: string;
  entityId: string;
  flexPortalMatchFlags: [
    'WAITING_FOR_REPLY' | 'ONE_REPLIED_AVAILABLE' | 'ALL_REPLIED_UNAVAILABLE'
  ];
  dutyCodeOrganizationalUnitId: number;
  flexPortalMatchStatus:
    | 'ACCEPT_REQUEST'
    | 'CONNECT_EMPLOYEE'
    | 'EMPLOYEE_CONFIRM';
  isAutoMatch: boolean;
  taskDefinitionKey: string;
  askedEmployees: {
    employeeId: number;
    nameInformal: string;
  }[];
  periodHours: number;
  createTime: ISODateString;
  poolId: number;
  preferredEmployees: PreferredEmployee[];
  costCenterName: string;
  taskName: string;
  actions: [FlexRequestActionType];
  remarks: string;
  taskId: string;
  statusCode: string;
}

export type AddFlexMatchRequestPayload = {
  costCenterId: number;
  functionId: number;
  dutyId: number;
  date: string;
  reason: string;
  notes?: DutyLineNote[];
  qualifications: { qualificationId: string }[];
  preferredEmployees: { employeeId: number; createdBy: CreatedBy }[];
};

export type AvailabilityStatus =
  | 'NOT_PROVIDED'
  | 'AVAILABLE'
  | 'UNAVAILABLE'
  | string;

export enum MatchCandidateTypeEnum {
  ASKED = 'ASKED',
  PREFERRED_PLANNER = 'PREFERRED_PLANNER',
  PREFERRED_FLEX_PLANNER = 'PREFERRED_FLEX_PLANNER',
  PROPOSED_EXTERNAL = 'PROPOSED_EXTERNAL',
  REPLIED_AVAILABLE = 'REPLIED_AVAILABLE',
  REPLIED_NOT_AVAILABLE = 'REPLIED_NOT_AVAILABLE',
  ALL_REPLIED_UNAVAILABLE = 'ALL_REPLIED_UNAVAILABLE',
  SUBSCRIBED = 'SUBSCRIBED'
}

export type MatchCandidateType =
  | MatchCandidateTypeEnum.ASKED
  | MatchCandidateTypeEnum.PREFERRED_PLANNER
  | MatchCandidateTypeEnum.PREFERRED_FLEX_PLANNER
  | MatchCandidateTypeEnum.PROPOSED_EXTERNAL
  | MatchCandidateTypeEnum.REPLIED_AVAILABLE
  | MatchCandidateTypeEnum.REPLIED_NOT_AVAILABLE
  | MatchCandidateTypeEnum.ALL_REPLIED_UNAVAILABLE
  | MatchCandidateTypeEnum.SUBSCRIBED;

export interface Availability {
  availability: AvailabilityStatus;
  percentage: number;
}

export interface MatchCandidateResponse {
  employeeId: number;
  employeeEntityId: string;
  employeeNr: number;
  employeeName: string;
  comPhone: string | null;
  comPhoneAlt: string | null;
  comSms: string | null;
  comEmail: string | null;
  workAgreementId: number;
  workAgreementNr: number;
  sourceCostCenter: string;
  functionName: string;
  balanceHours: number;
  workRelation: string;
  dutyOverlap: boolean;
  availablePercentage: number;
  wabPercentage: number;
  matchedOn: ISODateString | null;
  askedTaskId: number | null;
  availabilities: Availability[];
  sameDayDutyIds: number[];
  matchCandidateTypes: MatchCandidateType[];
  matchRemark: string | null;
}

export type AskEmployeeMessageResponse = {
  body: string;
  subject: string;
};

export type FlexMatchQualificationMutationPayload = {
  type: 'add' | 'remove';
  body: {
    qualificationId: string;
    requestId: number;
  };
};
